<template>
  <div>
    <v-row>
      <v-col>
        <exo-input-date-time
          :root="_self"
          name="startDate"
          :forceDisplay="true"
          forcedLabel="Ignore all data before"
          :datePickerProps="{ 'show-current': truncatedDataStartDate }"
          :key="startDateReloadKey"
        />
      </v-col>
      <v-col>
        <exo-input-date-time
          :root="_self"
          name="endDate"
          :forceDisplay="true"
          forcedLabel="Ignore all data after"
          :datePickerProps="{ 'show-current': truncatedDataEndDate }"
          :key="endDateReloadKey"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        ><SimulationIdSelector
          :updating="true"
          :typeToDisplayProp.sync="inputs.measurementsType"
          :selectedIdsProp.sync="inputs.simulationIds"
        ></SimulationIdSelector
      ></v-col>
    </v-row>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import SimulationIdSelector from './SimulationIdSelector'

export default {
  name: 'MeasurementsSelector',

  mixins: [formMixin, numericalMixin],

  props: {
    measurementsselector: {
      type: Object,
      default: () => null
    },
    dataStartDate: {
      type: String,
      default: null
    },
    dataEndDate: {
      type: String,
      default: null
    }
  },

  components: {
    SimulationIdSelector
  },

  watch: {
    inputs: {
      handler(newValue) {
        if (newValue != null) {
          this.$emit('update:measurementsselector', this.createObjectFromForm())
        }
      },
      deep: true
    },
    measurementsselector: {
      handler(newValue) {
        if (this.measurementsselector != null) {
          this.inputs.noradID = newValue.noradID
          this.inputs.startDate = newValue.startDate
          this.inputs.endDate = newValue.endDate
          this.inputs.measurementsType = newValue.measurementsType
          this.inputs.simulationIds = newValue.simulationIds
        }
      },
      deep: true
    },
    inputsValid: {
      handler(newValue) {
        this.$emit('updateValidation', newValue)
      }
    },
    dataStartDate(newValue) {
      if (!this.inputs.startDate) {
        this.startDateReloadKey++
      }
    },
    dataEndDate(newValue) {
      if (!this.inputs.endDate) {
        this.endDateReloadKey--
      }
    }
  },

  computed: {
    truncatedDataStartDate() {
      return this.dataStartDate.substring(0, 10)
    },
    truncatedDataEndDate() {
      return this.dataEndDate.substring(0, 10)
    }
  },

  data() {
    return {
      inputs: {
        name: 'measurementsSelector',
        noradID: this.getDefaultValue('noradID'),
        startDate: this.getDefaultValue('startDate'),
        endDate: this.getDefaultValue('endDate'),
        measurementsType: 'ALL',
        simulationIds: null
      },
      enableFormCache: false,
      startDateReloadKey: 0,
      endDateReloadKey: 0
    }
  },

  methods: {
    getCurrentFormType() {
      return 'MeasurementsSelector'
    },

    refreshTable() {}
  }
}
</script>
